var render = function render(){var _vm=this,_c=_vm._self._c;return _c('span',[(_vm.updateAvailable)?_c('el-tag',{attrs:{"type":"info"}},[_c('a',{attrs:{"href":"https://github.com/johnsusek/praeco/releases","target":"_blank"}},[_vm._v(" Update available ")])]):_vm._e(),_c('el-tag',{staticClass:"m-w-xs",attrs:{"type":"info"}},[_vm._v("praeco "+_vm._s(_vm.currentVersion))])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }